import React from 'react'
import styles from './DetailAccount.module.css'
import { FaHome } from 'react-icons/fa';
import adlogo from '../Images/AdManagerLogo.png'
import Billlogo from '../Images/BillingLogo.png'
import plus from '../Images/Plus.png'
import { Link } from "react-router-dom";

const DetailAccount = () => {
    return (
        <>
            <div className={styles.home}>
                <div className={styles.side}>
                    <Link to="/home" className={styles.homeTitle}>
                        <FaHome size={22} className={styles.logo} />
                        <div className={styles.text}>Home</div>
                    </Link>
                    <Link to="/admanager" className={styles.manager}>
                        <div className={styles.admanag}><img src={adlogo} alt="" /></div>
                        <div className={styles.text}>Ad manager</div>
                    </Link>
                    <Link to="/billing" className={styles.manager}>
                        <div className={styles.admanag}><img src={Billlogo} alt="" /></div>
                        <div className={styles.text}>Billing</div>
                    </Link>

                </div>
                <div className={styles.right}>
                    <div className={styles.inner}>
                        <div className={styles.upload}>
                            <img src={plus} alt="" style={{ width: "11px" }} />
                            <div className={styles.textLogo}>Upload <br /> Logo</div>
                        </div>
                        <div className={styles.details}>
                            <div className={styles.heading}>Business details</div>
                            <div className={styles.detail}>
                                <div className={styles.first}>First name</div>
                                <input type="text" placeholder='First name' className={styles.inputInner} />
                                <div className={styles.first}>Last name</div>
                                <input type="text" placeholder='Last name' className={styles.inputInner} />
                            </div>
                            <div className={styles.company}>
                                <div className={styles.companyHeading}>Company name and address</div>
                                <input type="text" placeholder='Company name' className={styles.inputInner} />
                                <input type="text" placeholder='Company address' className={styles.inputInner} />
                                <input type="text" placeholder='Country business' className={styles.inputInner} />
                            </div>
                            <div className={styles.tax}>
                                <div className={styles.companyHeading}>Tax info</div>
                                <input type="text" placeholder='Chamber of commerce' className={styles.inputInner} />
                                <input type="text" placeholder='VAT number' className={styles.inputInner} />
                            </div>
                            <button className={styles.save}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DetailAccount
